export const styles = theme => ({
  boxContent: {
    border: '1px solid #ccc',
  },
  title: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '16px',
    fontWeight: '400',
  },

});